import { render } from "./i-edit.vue?vue&type=template&id=d67a0e46"
import script from "./i-edit.vue?vue&type=script&lang=js"
export * from "./i-edit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__